import * as bulmaToast from "bulma-toast";
import * as bulmaStyle from 'components/style.scss';
import * as toastStyle from './style.scss';

const toastInit = () => {
    // @ts-ignore
    bulmaToast.setDoc(window.document);

    // toastShow({title: 'Notification', message: 'This is the message, and it is really long to test how long once work. Bad/good?', type: 'success', duration:10000000});
    // toastShow({title: 'Notification', message: 'This is the message, and it is really long to test how long once work. Bad/good?', type: 'info', duration:10000000});
    // toastShow({title: 'Notification', message: 'This is the message, and it is really long to test how long once work. Bad/good?', type: 'warning', duration:10000000});
    // toastShow({title: 'Notification', message: 'This is the message, and it is really long to test how long once work. Bad/good?', type: 'danger', duration:10000000});
}

type ToastType = 'success' | 'info' | 'warning' | 'danger';

interface ToastProps {
    title: string,
    message?: string,
    duration?: number,
    type: ToastType,
}


const toastShow = (props: ToastProps) => {
    const style: { [key in ToastType]: any} = {
        'success': {
            toastStyle: toastStyle.toastSuccess,
            bulmaStyle: 'is-success',
        },
        'info': {
            toastStyle: toastStyle.toastInfo,
            bulmaStyle: 'is-info',
        },
        'warning': {
            toastStyle: toastStyle.toastWarning,
            bulmaStyle: 'is-warning',
        },
        'danger': {
            toastStyle: toastStyle.toastDanger,
            bulmaStyle: 'is-danger',
        },
    };
    bulmaToast.toast({
        message: `<div class="${toastStyle.toast} ${style[props.type].toastStyle}"><p class="${toastStyle.toastTitle}">${props.title}</p><p class="${toastStyle.toastMessage}">${props.message}</p></div>`,
        type: style[props.type].bulmaStyle,
        dismissible: true,
        pauseOnHover: true,
        duration: props.duration
      });
}

export {
    toastInit as init,
    toastShow as show,
};